import { PlaceholdersId, TFComponent } from '@types';
import { AccountSelectorPlaceholder } from './accountSelector';

export const accountSelector: TFComponent = {
	component: AccountSelectorPlaceholder,
	id: PlaceholdersId.accountSelector,
	name: 'accountSelector',
};
